var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxsave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 444.392,
    height: 405.108,
    viewBox: "0 0 444.392 405.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taxsave",
    transform: "translate(-27.804 -45.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4626",
    "data-name": "Group 4626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4620",
    "data-name": "Group 4620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4619",
    "data-name": "Group 4619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M180.329,183.4a60.882,60.882,0,1,1-68.984-51.352A60.816,60.816,0,0,1,180.329,183.4Z",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4622",
    "data-name": "Group 4622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4621",
    "data-name": "Group 4621"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M165.993,185.488a46.4,46.4,0,1,1-52.57-39.134A46.343,46.343,0,0,1,165.993,185.488Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4625",
    "data-name": "Group 4625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4624",
    "data-name": "Group 4624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4623",
    "data-name": "Group 4623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M165.773,184.051c-.277.051-.765-1.936-2.016-5.345a49.223,49.223,0,0,0-7.341-13.3,47.518,47.518,0,0,0-7.291-7.459,46.479,46.479,0,0,0-10.138-6.267,45.508,45.508,0,0,0-12.613-3.631,45.041,45.041,0,0,0-6.939-.4,45.324,45.324,0,0,0-14.057,2.494A45.223,45.223,0,0,0,99,152.9a45.432,45.432,0,0,0-10.593,7.751,46.442,46.442,0,0,0-7.359,9.375,47.533,47.533,0,0,0-4.277,9.514,49.26,49.26,0,0,0-2.309,15.013c0,3.63.227,5.664-.051,5.71-.2.041-.9-1.917-1.331-5.636a42.94,42.94,0,0,1,1.278-15.792A46.464,46.464,0,0,1,86.086,158.35a44.873,44.873,0,0,1,5.19-4.584,45.456,45.456,0,0,1,6.078-3.925,47.314,47.314,0,0,1,6.861-3.039,47.523,47.523,0,0,1,15.163-2.691,47.32,47.32,0,0,1,7.487.493,47.331,47.331,0,0,1,13.509,4.109,46.5,46.5,0,0,1,18.066,15.2,42.954,42.954,0,0,1,6.641,14.387C165.955,181.941,165.978,184.017,165.773,184.051Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4630",
    "data-name": "Group 4630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4629",
    "data-name": "Group 4629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4628",
    "data-name": "Group 4628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4627",
    "data-name": "Group 4627"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M129.254,218.791l1.278,7.981-7.125,1.138-1.243-7.765c-7.122.7-14.244-.422-18.652-2.859l2.525-9.32a29.154,29.154,0,0,0,14.633,2.845l-1.906-11.9c-8.217-.655-17.473-1.877-19.1-12.067-1.209-7.553,3.239-14.914,14.29-18l-1.266-7.91,7.125-1.141,1.244,7.768a32.625,32.625,0,0,1,15.158,2.029l-2.158,9.335a29.573,29.573,0,0,0-11.5-1.961l1.941,12.114c8.2.584,17.319,1.831,18.927,11.875C144.612,208.367,140.223,215.646,129.254,218.791Zm-12.166-30.352-1.622-10.116c-3.638,1.459-4.8,3.765-4.427,6.117C111.439,186.932,113.793,187.945,117.088,188.439Zm15.005,15.21c-.4-2.495-2.683-3.516-5.918-4.1l1.574,9.833C131.187,208.032,132.457,205.929,132.093,203.649Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4644",
    "data-name": "Group 4644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4639",
    "data-name": "Group 4639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4633",
    "data-name": "Group 4633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4632",
    "data-name": "Group 4632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M401.394,128.666a44.243,44.243,0,1,1-60.716-14.811A44.193,44.193,0,0,1,401.394,128.666Z",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4634",
    "data-name": "Group 4634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M392.392,134.124a33.716,33.716,0,1,1-46.27-11.288A33.677,33.677,0,0,1,392.392,134.124Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4638",
    "data-name": "Group 4638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4637",
    "data-name": "Group 4637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M391.837,133.224c-.171.113-1.061-1.078-2.863-3.005a35.8,35.8,0,0,0-8.683-6.821,34.568,34.568,0,0,0-6.993-2.925,33.747,33.747,0,0,0-8.56-1.32,33.094,33.094,0,0,0-9.469,1.145,32.716,32.716,0,0,0-4.759,1.7,32.9,32.9,0,0,0-8.7,5.653,32.738,32.738,0,0,0-3.483,3.66,33.076,33.076,0,0,0-4.892,8.19,33.75,33.75,0,0,0-2.267,8.359,34.527,34.527,0,0,0-.165,7.578,35.8,35.8,0,0,0,2.71,10.7c1.03,2.428,1.757,3.725,1.584,3.835-.125.085-1.143-1.029-2.488-3.394a31.194,31.194,0,0,1-3.621-10.93,33.78,33.78,0,0,1,2.04-17.034,32.7,32.7,0,0,1,2.174-4.539,33.09,33.09,0,0,1,2.956-4.349,34.321,34.321,0,0,1,3.729-3.978,34.54,34.54,0,0,1,9.384-6.1,34.54,34.54,0,0,1,5.149-1.793,34.425,34.425,0,0,1,10.2-1.078,33.8,33.8,0,0,1,16.4,5.049,31.222,31.222,0,0,1,8.521,7.746C391.361,131.761,391.965,133.143,391.837,133.224Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4643",
    "data-name": "Group 4643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4642",
    "data-name": "Group 4642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4641",
    "data-name": "Group 4641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4640",
    "data-name": "Group 4640"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M377.246,166.821l3.118,4.978-4.445,2.782-3.033-4.844c-4.567,2.488-9.651,3.755-13.291,3.373l-.952-6.952a21.2,21.2,0,0,0,10.6-2.243l-4.648-7.423c-5.684,1.891-12.224,3.7-16.2-2.66-2.949-4.711-2.059-10.9,4.461-16.093l-3.089-4.935,4.445-2.783,3.033,4.846a23.712,23.712,0,0,1,10.719-2.939l1.2,6.859a21.513,21.513,0,0,0-8.249,1.945l4.732,7.557c5.656-1.934,12.109-3.684,16.032,2.582C384.569,155.494,383.7,161.608,377.246,166.821ZM360.5,149.959l-3.952-6.31c-2.021,2.008-2.147,3.882-1.229,5.349C356.3,150.552,358.158,150.563,360.5,149.959Zm14.352,5.925c-.975-1.556-2.792-1.592-5.122-1.064l3.841,6.134C375.49,159.074,375.745,157.307,374.855,155.884Z",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4657",
    "data-name": "Group 4657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4652",
    "data-name": "Group 4652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4646",
    "data-name": "Group 4646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4645",
    "data-name": "Group 4645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M341.818,87.714a22.782,22.782,0,1,1,7.074-31.393A22.756,22.756,0,0,1,341.818,87.714Z",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4648",
    "data-name": "Group 4648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4647",
    "data-name": "Group 4647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M338.926,83.129a17.361,17.361,0,1,1,5.392-23.924A17.342,17.342,0,0,1,338.926,83.129Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4651",
    "data-name": "Group 4651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4650",
    "data-name": "Group 4650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4649",
    "data-name": "Group 4649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M339.385,82.835c-.06-.087.545-.556,1.521-1.5a18.451,18.451,0,0,0,3.433-4.532,17.741,17.741,0,0,0,1.442-3.627,17.354,17.354,0,0,0,.6-4.418,17,17,0,0,0-.675-4.865,16.839,16.839,0,0,0-.916-2.434,16.968,16.968,0,0,0-2.99-4.428,16.912,16.912,0,0,0-1.916-1.76,17.018,17.018,0,0,0-4.26-2.444,17.366,17.366,0,0,0-4.324-1.092,17.842,17.842,0,0,0-3.9-.016,18.427,18.427,0,0,0-5.484,1.492,10.138,10.138,0,0,1-1.961.851c-.044-.064.52-.6,1.726-1.312a16.061,16.061,0,0,1,5.594-1.963,17.378,17.378,0,0,1,8.788.9,16.685,16.685,0,0,1,2.356,1.078,16.9,16.9,0,0,1,2.266,1.482,17.691,17.691,0,0,1,2.082,1.884,19.015,19.015,0,0,1,1.807,2.256A19.274,19.274,0,0,1,345.99,60.9a17.776,17.776,0,0,1,.969,2.635,16.922,16.922,0,0,1,.528,2.655,16.7,16.7,0,0,1,.12,2.589,17.385,17.385,0,0,1-2.451,8.488,16.071,16.071,0,0,1-3.91,4.457A5.093,5.093,0,0,1,339.385,82.835Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4656",
    "data-name": "Group 4656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4655",
    "data-name": "Group 4655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4654",
    "data-name": "Group 4654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4653",
    "data-name": "Group 4653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M321.955,75.628l-2.534,1.65-1.473-2.263,2.467-1.6a12.794,12.794,0,0,1-1.858-6.813l3.571-.553a10.915,10.915,0,0,0,1.251,5.436l3.779-2.46c-1.025-2.909-2.014-6.26,1.223-8.367,2.4-1.561,5.592-1.159,8.326,2.151l2.512-1.635,1.473,2.263-2.467,1.606a12.206,12.206,0,0,1,1.61,5.491l-3.52.681a11.071,11.071,0,0,0-1.076-4.229l-3.848,2.5c1.047,2.894,2.007,6.2-1.184,8.277C327.854,79.295,324.7,78.9,321.955,75.628Zm8.53-8.773,3.212-2.092c-1.052-1.023-2.017-1.07-2.764-.585C330.141,64.694,330.152,65.653,330.485,66.855ZM327.564,74.3c.793-.516.8-1.451.5-2.646l-3.123,2.033C325.928,74.653,326.84,74.768,327.564,74.3Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Desk"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4659",
    "data-name": "Group 4659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4658",
    "data-name": "Group 4658"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M472.2,450.443c0,.144-99.489.261-222.185.261-122.74,0-222.207-.117-222.207-.261s99.467-.26,222.207-.26C372.707,450.183,472.2,450.3,472.2,450.443Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4691",
    "data-name": "Group 4691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4663",
    "data-name": "Group 4663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4662",
    "data-name": "Group 4662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4661",
    "data-name": "Group 4661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4660",
    "data-name": "Group 4660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M87.257,419.739c1.129-4.374-1.739-8.765-4.954-11.939s-7.059-6.016-8.732-10.212c-2.71-6.8.933-15.6-3.691-21.273-2.72-3.336-7.6-4.453-10.012-8.017-1.267-1.87-1.676-4.168-2.174-6.371A64.709,64.709,0,0,0,41.6,331.816a56.137,56.137,0,0,0,6.313,29.02c1.873,3.567,4.172,7.043,4.793,11.023,1.007,6.463-2.6,13.12-1.012,19.466,1.815,7.257,9.967,12.114,10.354,19.585.327,6.316-5.178,11.859-4.768,18.17a17.05,17.05,0,0,0,2.81,7.49c4.884,8.118,12.057,13.71,22.931,13.528l13.318.466Z",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4668",
    "data-name": "Group 4668",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4667",
    "data-name": "Group 4667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4666",
    "data-name": "Group 4666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4665",
    "data-name": "Group 4665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4664",
    "data-name": "Group 4664"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M87.257,419.739c1.129-4.374-1.739-8.765-4.954-11.939s-7.059-6.016-8.732-10.212c-2.71-6.8.933-15.6-3.691-21.273-2.72-3.336-7.6-4.453-10.012-8.017-1.267-1.87-1.676-4.168-2.174-6.371A64.709,64.709,0,0,0,41.6,331.816a56.137,56.137,0,0,0,6.313,29.02c1.873,3.567,4.172,7.043,4.793,11.023,1.007,6.463-2.6,13.12-1.012,19.466,1.815,7.257,9.967,12.114,10.354,19.585.327,6.316-5.178,11.859-4.768,18.17a17.05,17.05,0,0,0,2.81,7.49c4.884,8.118,12.057,13.71,22.931,13.528l13.318.466Z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4690",
    "data-name": "Group 4690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4679",
    "data-name": "Group 4679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4673",
    "data-name": "Group 4673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4672",
    "data-name": "Group 4672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4671",
    "data-name": "Group 4671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4670",
    "data-name": "Group 4670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4669",
    "data-name": "Group 4669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M99.039,450.474a10.617,10.617,0,0,0,3.667-.079,22.267,22.267,0,0,0,4.328-1.089,18.36,18.36,0,0,0,5.345-2.928,7.448,7.448,0,0,0,2.2-2.93,13.8,13.8,0,0,0,.627-3.979,38.583,38.583,0,0,1,.31-4.308,11.874,11.874,0,0,1,1.628-4.283c1.57-2.759,4.177-5.37,5.02-9.115.911-3.684.257-7.671-.362-11.675s-1.218-8.349.311-12.511c1.428-4.165,4.349-7.926,5.809-12.621,1.454-4.743.777-9.844,1.084-14.875a19.73,19.73,0,0,1,1.735-7.395c1.078-2.357,2.572-4.58,3.739-7.062,2.364-5.018,2.781-10.7,3.428-16.277q.473-4.21.955-8.51a41.712,41.712,0,0,1,1.48-8.517,75.179,75.179,0,0,1,3.186-8.242,27.431,27.431,0,0,0,1.546-4.3,43.413,43.413,0,0,0,.43-4.581,54.047,54.047,0,0,0-.355-9.219c-.362-3.074-.916-6.12-1.247-9.2-.02-.181-.041-.363-.059-.531l-.069-.613-.546.273a20.591,20.591,0,0,0-7.169,6.05,32.661,32.661,0,0,0-4.4,8.118c-2.225,5.722-3.026,11.719-4.147,17.441-1.1,5.722-2.539,11.351-5.473,16.107-1.459,2.372-3.225,4.538-4.77,6.851a18.835,18.835,0,0,0-3.305,7.591c-.788,5.634,2.316,10.582,1.67,15.571a17.274,17.274,0,0,1-2.43,6.912c-1.209,2.128-2.631,4.1-3.979,6.084a39.094,39.094,0,0,0-3.575,6.145,19.453,19.453,0,0,0-1.636,6.677c-.325,4.491.312,8.752-.016,12.774a29.417,29.417,0,0,1-3.287,10.946c-1.611,3.276-3.4,6.239-4.9,9.113a46.961,46.961,0,0,0-2.019,4.244,20.966,20.966,0,0,0-1.169,4.21,26.589,26.589,0,0,0-.1,7.6,19.159,19.159,0,0,0,3.81,9.694A9.267,9.267,0,0,0,97.4,449.2a5.4,5.4,0,0,0,.874.743c.5.366.762.533.762.533a16.792,16.792,0,0,1-2.579-2.55,19.286,19.286,0,0,1-3.615-9.629,26.387,26.387,0,0,1,.17-7.491,20.467,20.467,0,0,1,1.178-4.112,46.487,46.487,0,0,1,2.031-4.188c1.513-2.847,3.324-5.8,4.969-9.1a29.884,29.884,0,0,0,3.4-11.139c.35-4.107-.269-8.383.071-12.769a18.8,18.8,0,0,1,1.605-6.452,38.5,38.5,0,0,1,3.534-6.022c1.348-1.97,2.786-3.951,4.03-6.123a18,18,0,0,0,2.541-7.2c.642-5.314-2.439-10.3-1.638-15.532a18.069,18.069,0,0,1,3.193-7.261c1.52-2.27,3.3-4.438,4.8-6.869,3.026-4.893,4.493-10.63,5.6-16.376,1.132-5.758,1.934-11.691,4.119-17.3a31.844,31.844,0,0,1,4.29-7.9,19.731,19.731,0,0,1,6.867-5.8l-.614-.34c.019.169.04.353.061.537.335,3.117.891,6.17,1.248,9.208a53.053,53.053,0,0,1,.353,9.078,43.371,43.371,0,0,1-.409,4.443,26.866,26.866,0,0,1-1.494,4.152,75.6,75.6,0,0,0-3.211,8.333,42.45,42.45,0,0,0-1.5,8.659q-.477,4.3-.945,8.516c-.636,5.6-1.054,11.192-3.33,16.035-1.125,2.412-2.617,4.642-3.726,7.076a20.5,20.5,0,0,0-1.785,7.668c-.29,5.14.378,10.164-1.012,14.717-1.381,4.531-4.286,8.311-5.754,12.609-1.571,4.342-.92,8.84-.285,12.822.643,4.009,1.289,7.912.431,11.453-.77,3.577-3.3,6.165-4.905,9a12.337,12.337,0,0,0-1.652,4.454,38.586,38.586,0,0,0-.28,4.36,13.488,13.488,0,0,1-.568,3.871,7.135,7.135,0,0,1-2.066,2.8,18.274,18.274,0,0,1-5.217,2.942,22.94,22.94,0,0,1-4.267,1.158,16.98,16.98,0,0,1-2.709.261C99.357,450.464,99.039,450.474,99.039,450.474Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4678",
    "data-name": "Group 4678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4677",
    "data-name": "Group 4677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4676",
    "data-name": "Group 4676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4675",
    "data-name": "Group 4675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4674",
    "data-name": "Group 4674"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M141.121,293.575a1.523,1.523,0,0,0-.129.4l-.294,1.2c-.262,1.049-.575,2.633-1.077,4.612-.523,1.972-1.731,4.2-2.765,6.956-1.074,2.729-2.163,5.892-3.165,9.447s-1.917,7.495-2.858,11.721c-.971,4.217-1.939,8.74-4.263,13.006-1.092,2.164-2.321,4.353-3.3,6.749a31.475,31.475,0,0,0-1.918,7.642,154.154,154.154,0,0,1-2.871,16.113c-2.67,10.914-5.214,21.309-7.53,30.774-2.372,9.433-4.509,17.934-6.311,25.1-1.754,7.1-3.178,12.87-4.183,16.939q-.694,2.93-1.1,4.617c-.106.488-.193.885-.263,1.2a1.584,1.584,0,0,0-.062.418,1.53,1.53,0,0,0,.146-.4c.092-.315.206-.705.347-1.185.3-1.112.721-2.641,1.25-4.576,1.069-4.053,2.583-9.8,4.447-16.872,1.853-7.153,4.05-15.638,6.489-25.054,2.338-9.468,4.906-19.865,7.6-30.782a152.272,152.272,0,0,0,2.866-16.179,30.733,30.733,0,0,1,1.846-7.458c.941-2.334,2.151-4.513,3.243-6.7,2.343-4.347,3.319-9.007,4.252-13.208.912-4.236,1.774-8.169,2.747-11.713s2-6.7,3.03-9.437c.98-2.742,2.149-5,2.639-7.04.462-2.027.715-3.6.924-4.663.086-.493.155-.893.211-1.217A1.6,1.6,0,0,0,141.121,293.575Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4689",
    "data-name": "Group 4689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4683",
    "data-name": "Group 4683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4682",
    "data-name": "Group 4682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4681",
    "data-name": "Group 4681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M101.392,450.564c8.7-5.171,11.193-20.475,7.565-29.922S98.976,402.564,98,392.491c-.753-7.743,1.783-15.689-.021-23.257-2.433-10.213-12.4-18.123-12.289-28.622.064-5.89,3.416-11.432,3.149-17.317-.328-7.218-5.868-12.945-9.3-19.3-5.253-9.733-5.6-21.24-7.394-32.153s-5.955-22.6-15.626-27.963c-1.429,9.265-3.867,15.61-3.1,28.162.275,4.507,5.511,13.136,6.224,23.015.425,5.9.72,11.818,1.081,17.727.351,5.75.724,11.605,2.785,16.984,1.579,4.123,4.117,7.868,5.29,12.124,2.206,8.007-.693,16.679,1.089,24.791,1.509,6.873,6.266,12.788,7.238,19.757,1.365,9.793-4.972,19.967-1.728,29.307,1.609,4.634,5.422,8.356,6.5,13.142.839,3.713-.076,7.643.684,11.374,1.225,6.009,12.687,10.676,18.809,10.3",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4688",
    "data-name": "Group 4688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4686",
    "data-name": "Group 4686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4685",
    "data-name": "Group 4685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4684",
    "data-name": "Group 4684"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M58.914,253.073a2.476,2.476,0,0,0,.038.523c.05.389.115.891.2,1.523.2,1.338.424,3.3.876,5.843.486,2.555,1.8,5.431,2.855,8.9,1.11,3.458,2.214,7.447,3.19,11.912.993,4.464,1.823,9.4,2.695,14.721.9,5.277,1.822,11.109,4.459,16.644,1.221,2.781,2.59,5.564,3.617,8.529a38.326,38.326,0,0,1,1.835,9.4,189.631,189.631,0,0,0,2.551,20.265c2.665,13.728,5.2,26.8,7.512,38.7,2.435,11.855,4.628,22.534,6.475,31.525L99.651,442.8c.532,2.46.951,4.391,1.249,5.766.143.619.257,1.113.346,1.495a2.379,2.379,0,0,0,.146.5,2.315,2.315,0,0,0-.061-.521c-.067-.386-.154-.885-.262-1.512l-1.092-5.8c-1-5.085-2.418-12.345-4.171-21.293-1.8-9-3.928-19.693-6.295-31.561-2.288-11.9-4.8-24.97-7.442-38.693a192.058,192.058,0,0,1-2.56-20.2,38.95,38.95,0,0,0-1.9-9.588c-1.059-3.028-2.447-5.823-3.667-8.581-2.622-5.453-3.543-11.148-4.482-16.444-.9-5.308-1.769-10.262-2.8-14.734-1.018-4.476-2.168-8.472-3.326-11.929-1.1-3.479-2.461-6.331-2.983-8.821-.5-2.494-.778-4.478-1.032-5.8-.116-.626-.208-1.124-.28-1.509A2.307,2.307,0,0,0,58.914,253.073Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4713",
    "data-name": "Group 4713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4694",
    "data-name": "Group 4694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4693",
    "data-name": "Group 4693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4692",
    "data-name": "Group 4692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M437.993,390.966a11.131,11.131,0,0,1,5.769,6.534,19.667,19.667,0,0,1,.766,8.852c-.651,5.744-3.915,11.543-7.429,16.132-4.837-4.221-5.95-11.585-6.28-15.356-.522-5.961,2.156-17.051,7.174-16.162",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4697",
    "data-name": "Group 4697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4696",
    "data-name": "Group 4696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4695",
    "data-name": "Group 4695"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M442.721,431.965a9.5,9.5,0,0,1,3.069-9.028,12.611,12.611,0,0,1,9.3-2.906,5.311,5.311,0,0,1,4.083,1.834,4.062,4.062,0,0,1,.062,4.116,8.239,8.239,0,0,1-3.047,3c-4.191,2.63-8.73,4.4-13.469,2.983",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4701",
    "data-name": "Group 4701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4700",
    "data-name": "Group 4700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4699",
    "data-name": "Group 4699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4698",
    "data-name": "Group 4698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M436.518,449.578a6.691,6.691,0,0,1,.172-1.179c.153-.83.349-1.9.585-3.19a33.342,33.342,0,0,1,3.293-10.191,20.4,20.4,0,0,1,7.313-7.771,13.767,13.767,0,0,1,2.982-1.319,8.216,8.216,0,0,1,.859-.218.869.869,0,0,1,.307-.043,21.571,21.571,0,0,0-3.995,1.834,21.053,21.053,0,0,0-7.1,7.721,35.869,35.869,0,0,0-3.368,10.047c-.293,1.336-.531,2.42-.716,3.164A6.291,6.291,0,0,1,436.518,449.578Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4705",
    "data-name": "Group 4705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4704",
    "data-name": "Group 4704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4703",
    "data-name": "Group 4703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4702",
    "data-name": "Group 4702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M436.7,399.591a2.312,2.312,0,0,1,.059.515c.023.382.052.873.088,1.481.069,1.286.145,3.148.219,5.449.149,4.6.265,10.964.236,17.991s-.2,13.39-.392,17.992c-.094,2.3-.186,4.161-.266,5.447-.041.607-.075,1.1-.1,1.479a2.475,2.475,0,0,1-.064.515,2.388,2.388,0,0,1-.021-.518c.006-.383.013-.875.022-1.483.033-1.339.078-3.188.133-5.45.113-4.6.238-10.959.269-17.984s-.04-13.38-.113-17.982c-.036-2.262-.065-4.112-.086-5.451,0-.609-.007-1.1-.009-1.483A2.5,2.5,0,0,1,436.7,399.591Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4708",
    "data-name": "Group 4708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4707",
    "data-name": "Group 4707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4706",
    "data-name": "Group 4706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M434.352,435.462a22.216,22.216,0,0,0-12.13-16.274c-1.617-.774-3.727-1.28-5.056-.077s-1.033,3.365-.382,5.038a18.979,18.979,0,0,0,17.454,11.785",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4712",
    "data-name": "Group 4712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4711",
    "data-name": "Group 4711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4710",
    "data-name": "Group 4710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4709",
    "data-name": "Group 4709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M423.005,424.637a5.69,5.69,0,0,1,1.027.447,11,11,0,0,1,1.16.618c.434.272.959.537,1.476.927a19.223,19.223,0,0,1,1.689,1.271,21.787,21.787,0,0,1,1.8,1.633,24.688,24.688,0,0,1,3.416,4.39,24.187,24.187,0,0,1,2.251,5.088,21.106,21.106,0,0,1,.568,2.363,17.726,17.726,0,0,1,.29,2.1,16.593,16.593,0,0,1,.081,1.742,10.1,10.1,0,0,1-.039,1.313,5.818,5.818,0,0,1-.124,1.113c-.1,0,.069-1.6-.212-4.138a19.278,19.278,0,0,0-.337-2.058,22.054,22.054,0,0,0-.6-2.316,25.145,25.145,0,0,0-2.241-4.987,25.707,25.707,0,0,0-3.333-4.335,23.2,23.2,0,0,0-1.745-1.637c-.555-.507-1.126-.911-1.636-1.295C424.419,425.381,422.963,424.718,423.005,424.637Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5101",
    "data-name": "Group 5101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4786",
    "data-name": "Group 4786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4714",
    "data-name": "Group 4714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M367.162,231.209s-46.691-33.088-52.6-36.342c-5.633-3.1-23.5-5.351-25.1-5.741l-31.989-6.955-48.877,1.461-14.02,8.43L159.1,208.4a42.055,42.055,0,0,0-21.322,22.259l-22.4,54.71,55.588,16.442,1.73,57.71-13.111,90.921H322.3l-8.187-174.257,16.939,3.729Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4716",
    "data-name": "Group 4716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4715",
    "data-name": "Group 4715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M171.989,278.568s-.584.431-1.719,1.089a14.189,14.189,0,0,1-5.2,1.9,19.366,19.366,0,0,1-8.113-1.176,58.5,58.5,0,0,1-9.241-4.018c-3.172-1.651-6.138-3.324-8.924-4.669a49.461,49.461,0,0,0-7.617-3.044,29.553,29.553,0,0,0-5.416-1.1c-.651-.068-1.157-.1-1.5-.114s-.524-.039-.524-.039a15.343,15.343,0,0,1,2.033.073,28.077,28.077,0,0,1,5.45,1.041,48.313,48.313,0,0,1,7.66,3.012c2.8,1.339,5.768,3.009,8.936,4.657a59.526,59.526,0,0,0,9.2,4.021,19.417,19.417,0,0,0,8.035,1.212,14.431,14.431,0,0,0,5.174-1.827c.571-.319,1.01-.575,1.3-.757S171.989,278.568,171.989,278.568Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4718",
    "data-name": "Group 4718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4717",
    "data-name": "Group 4717"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M169.619,251.612s-.128.006-.37,0l-1.06-.05c-.92-.044-2.25-.145-3.889-.308a102.266,102.266,0,0,1-25.034-5.759c-1.545-.571-2.785-1.06-3.632-1.424l-.975-.417c-.222-.1-.334-.159-.334-.159s.123.035.35.12l.989.381c.856.34,2.1.808,3.652,1.36a110.374,110.374,0,0,0,25,5.752c1.635.181,2.962.3,3.88.373l1.056.089C169.493,251.589,169.619,251.612,169.619,251.612Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4720",
    "data-name": "Group 4720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4719",
    "data-name": "Group 4719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M204.586,194.867a20.949,20.949,0,0,1-1.3,1.823,25.483,25.483,0,0,1-4.336,4.283,38.369,38.369,0,0,1-7.756,4.641,78.892,78.892,0,0,1-10.4,3.8c-3.768,1.115-7.377,2.105-10.606,3.17a61.918,61.918,0,0,0-8.379,3.344,36.96,36.96,0,0,0-5.22,3.114c-.6.4-1.015.775-1.322,1s-.465.344-.465.344.588-.538,1.739-1.4a35.078,35.078,0,0,1,5.2-3.181,60.537,60.537,0,0,1,8.384-3.4c3.233-1.076,6.843-2.073,10.608-3.187a80.379,80.379,0,0,0,10.383-3.771,38.9,38.9,0,0,0,7.747-4.583,26.476,26.476,0,0,0,4.363-4.218c.477-.538.768-1.019,1.006-1.314S204.586,194.867,204.586,194.867Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4722",
    "data-name": "Group 4722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4721",
    "data-name": "Group 4721"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M304.636,202.324s-.149-.074-.423-.231-.666-.406-1.2-.674a30.633,30.633,0,0,0-4.645-2.012,51.536,51.536,0,0,0-7.274-1.867c-2.781-.531-5.869-.942-9.107-1.395L265.4,193.8l-5.023-.735-1.364-.21c-.312-.05-.474-.087-.474-.087s.166.008.48.045l1.369.172,5.033.67,16.594,2.287c3.238.454,6.329.871,9.115,1.414a50.021,50.021,0,0,1,7.287,1.916,28.75,28.75,0,0,1,4.634,2.08C304.1,201.936,304.636,202.324,304.636,202.324Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4724",
    "data-name": "Group 4724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4723",
    "data-name": "Group 4723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M281.974,213.362s-.37.173-1.083.486-1.769.766-3.142,1.315c-2.749,1.09-6.764,2.594-11.842,4.08a129.293,129.293,0,0,1-18.135,4c-6.93,1.063-14.659,1.065-22.716.8s-15.754-.615-22.732-.175a70.14,70.14,0,0,0-18.2,3.321,45.023,45.023,0,0,0-11.193,5.489c-1.2.865-2.12,1.546-2.7,2.061-.6.5-.922.749-.922.749s.3-.274.895-.781c.576-.526,1.492-1.219,2.685-2.1a44.443,44.443,0,0,1,11.192-5.562,69.8,69.8,0,0,1,18.233-3.373c6.991-.45,14.689-.1,22.75.158s15.767.273,22.683-.778a130.83,130.83,0,0,0,18.12-3.955c5.079-1.466,9.1-2.947,11.854-4.013,1.377-.537,2.44-.972,3.155-1.279S281.974,213.362,281.974,213.362Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4726",
    "data-name": "Group 4726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4725",
    "data-name": "Group 4725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M297.315,223.144a.691.691,0,0,1-.178.081l-.527.2c-.456.17-1.129.385-1.966.628a26.145,26.145,0,0,1-6.729,1.03,23.362,23.362,0,0,1-6.737-.967c-.835-.253-1.5-.48-1.956-.664l-.521-.209a.72.72,0,0,1-.176-.086.682.682,0,0,1,.191.046l.534.172c.459.16,1.132.365,1.968.6a24.872,24.872,0,0,0,6.7.9,28.176,28.176,0,0,0,6.692-.964c.839-.224,1.516-.417,1.98-.564l.538-.157A.705.705,0,0,1,297.315,223.144Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4728",
    "data-name": "Group 4728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4727",
    "data-name": "Group 4727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M265.769,251.436s-4.8,1.013-12.631,2.181c-3.916.59-8.6,1.175-13.808,1.694-5.213.493-10.957.909-17,1.139-6.042.209-11.8.21-17.039.1-5.235-.14-9.947-.384-13.9-.688-7.9-.6-12.755-1.261-12.755-1.261s.306.019.886.074l2.538.251c2.2.233,5.393.51,9.341.789s8.657.514,13.89.643c5.232.1,10.988.1,17.026-.112,6.035-.229,11.775-.639,16.986-1.122,5.208-.508,9.888-1.077,13.805-1.648s7.082-1.072,9.261-1.465l2.512-.433C265.465,251.477,265.769,251.436,265.769,251.436Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4730",
    "data-name": "Group 4730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4729",
    "data-name": "Group 4729"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M304.934,248.6s-.125.016-.363.025l-1.043.031c-.905.025-2.216.038-3.836.035-3.24-.009-7.719-.126-12.646-.549s-9.362-1.089-12.55-1.665c-1.594-.289-2.881-.541-3.766-.735l-1.019-.223c-.232-.053-.352-.092-.352-.092s.126.011.361.051l1.026.185,3.775.669c3.192.538,7.621,1.176,12.543,1.6s9.392.562,12.629.608l3.834.032,1.043.008C304.809,248.585,304.934,248.6,304.934,248.6Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4732",
    "data-name": "Group 4732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4731",
    "data-name": "Group 4731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M254.976,289.824s-.281.051-.82.129l-2.359.328c-1.023.148-2.277.321-3.744.415s-3.129.307-4.978.337c-1.848.063-3.872.166-6.047.129-1.087-.008-2.212.007-3.37-.02l-3.57-.117c-4.885-.2-10.249-.567-15.867-1.059-5.622-.473-10.973-.963-15.849-1.286-4.875-.3-9.273-.508-12.967-.455l-2.635.017-2.347.116c-1.466.062-2.729.128-3.754.257l-2.368.234c-.542.052-.828.068-.828.068s.282-.044.823-.109l2.365-.274c1.026-.142,2.288-.219,3.756-.292l2.349-.132,2.638-.032c3.7-.072,8.1.117,12.981.41,4.88.313,10.233.8,15.854,1.27,5.617.492,10.976.867,15.856,1.075l3.567.126c1.157.03,2.28.018,3.366.03,2.173.044,4.194-.049,6.04-.1,1.849-.021,3.511-.218,4.975-.306s2.72-.244,3.744-.38l2.363-.289C254.69,289.847,254.976,289.824,254.976,289.824Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4734",
    "data-name": "Group 4734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4733",
    "data-name": "Group 4733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M313.85,278.084s-.152.028-.443.061l-1.274.136c-1.107.117-2.711.252-4.7.386-3.97.272-9.47.467-15.541.311s-11.557-.647-15.506-1.127c-1.976-.238-3.571-.457-4.669-.632l-1.265-.2c-.289-.048-.439-.084-.439-.084s.154.008.445.043l1.27.163c1.1.151,2.7.348,4.674.567,3.951.441,9.429.9,15.495,1.065s11.558-.016,15.527-.249c1.984-.116,3.59-.228,4.7-.321l1.277-.1C313.7,278.084,313.85,278.084,313.85,278.084Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4736",
    "data-name": "Group 4736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4735",
    "data-name": "Group 4735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M314.558,314.424s-.5-.022-1.46-.086c-.958-.046-2.366-.2-4.187-.249-3.637-.185-8.914-.228-15.417.1s-14.227,1.088-22.764,2.213-17.9,2.575-27.756,3.846a241.8,241.8,0,0,1-27.943,2.127,128.341,128.341,0,0,1-22.81-1.654,91.172,91.172,0,0,1-14.951-3.772c-.87-.273-1.625-.563-2.275-.828l-1.65-.653c-.892-.353-1.356-.549-1.356-.549s.475.169,1.371.511l1.657.633c.652.258,1.408.543,2.28.809a92.95,92.95,0,0,0,14.948,3.7,129.383,129.383,0,0,0,22.784,1.607,244.338,244.338,0,0,0,27.918-2.142c9.856-1.27,19.214-2.727,27.758-3.83s16.27-1.877,22.781-2.169a153.082,153.082,0,0,1,15.429-.029C312.553,314.209,314.558,314.424,314.558,314.424Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4738",
    "data-name": "Group 4738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4737",
    "data-name": "Group 4737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M259.57,351.758s-4.808.82-12.646,1.658c-3.917.427-8.6.808-13.8,1.106-5.2.268-10.931.436-16.945.4-6.015-.053-11.742-.3-16.942-.646-5.2-.371-9.87-.82-13.781-1.3-7.825-.95-12.62-1.838-12.62-1.838s.3.033.877.114l2.51.367c1.089.167,2.422.363,3.975.555s3.316.453,5.275.656c3.911.464,8.582.9,13.777,1.258,5.2.332,10.92.575,16.931.629,6.009.032,11.733-.13,16.933-.387,5.2-.287,9.876-.653,13.793-1.061,1.962-.175,3.729-.4,5.284-.58s2.891-.347,3.983-.5l2.515-.331C259.266,351.786,259.57,351.758,259.57,351.758Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4740",
    "data-name": "Group 4740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4739",
    "data-name": "Group 4739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M313.956,344.6s-.181.067-.532.176l-1.537.465c-1.334.4-3.276.952-5.685,1.6-4.815,1.291-11.521,2.891-19.006,4.267s-14.326,2.252-19.287,2.753c-2.48.252-4.49.428-5.881.524l-1.6.11c-.367.023-.56.025-.56.025s.191-.03.556-.066l1.6-.15c1.389-.121,3.4-.319,5.873-.589,4.954-.538,11.783-1.444,19.265-2.812s14.183-2.951,19.006-4.2c2.412-.625,4.359-1.153,5.7-1.532l1.547-.427C313.767,344.639,313.956,344.6,313.956,344.6Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4742",
    "data-name": "Group 4742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4741",
    "data-name": "Group 4741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M221.423,393.454a72.769,72.769,0,0,1-7.782.764c-2.414.136-5.3.146-8.49.01a87.938,87.938,0,0,1-20.474-3.427c-3.065-.911-5.786-1.859-8.024-2.774a72.563,72.563,0,0,1-7.109-3.257s.175.068.5.216l1.41.656c.609.292,1.358.64,2.244,1.006s1.878.826,3.011,1.242c2.241.9,4.963,1.828,8.024,2.727a90.053,90.053,0,0,0,20.43,3.419c3.186.147,6.063.152,8.473.035,1.207-.024,2.295-.131,3.251-.194s1.779-.142,2.45-.221l1.547-.16C221.236,393.461,221.423,393.454,221.423,393.454Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4744",
    "data-name": "Group 4744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4743",
    "data-name": "Group 4743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M317.623,390.9s-.341.067-.994.174l-2.859.459c-2.483.4-6.081.94-10.532,1.576-8.9,1.273-21.226,2.849-34.879,4.207s-26.054,2.225-35.032,2.724c-4.489.251-8.123.427-10.636.524l-2.893.111c-.661.023-1.009.025-1.009.025s.347-.03,1.008-.067l2.891-.15,10.63-.59c8.975-.537,21.365-1.434,35.02-2.785s25.975-2.909,34.88-4.145l10.54-1.51,2.864-.42C317.277,390.942,317.623,390.9,317.623,390.9Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4746",
    "data-name": "Group 4746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4745",
    "data-name": "Group 4745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M322.864,427.732s-2.186.456-6.172,1.108-9.777,1.459-16.974,2.056a221.369,221.369,0,0,1-25.347.62c-9.547-.307-20-1.371-30.931-2.713s-21.346-2.694-30.862-3.437a198.686,198.686,0,0,0-25.325-.563,126.7,126.7,0,0,0-16.966,1.939c-1.982.381-3.516.7-4.548.953-1.036.236-1.582.35-1.582.35s.539-.141,1.573-.391c1.029-.266,2.561-.6,4.542-.991a123.611,123.611,0,0,1,16.973-2.007,196.818,196.818,0,0,1,25.349.518c9.522.734,19.937,2.084,30.871,3.422s21.375,2.411,30.912,2.728a224.1,224.1,0,0,0,25.329-.575c7.194-.578,12.986-1.367,16.974-1.989,1.993-.319,3.539-.571,4.585-.761S322.864,427.732,322.864,427.732Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4747",
    "data-name": "Group 4747"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M352.2,222.257s-.29.794-.939,2.175a40.03,40.03,0,0,1-3.266,5.574,72.259,72.259,0,0,1-6.02,7.454c-2.418,2.678-5.2,5.5-8.022,8.556a73.175,73.175,0,0,0-7.3,9.148,38.243,38.243,0,0,0-4.3,8.508,26.307,26.307,0,0,0-1.385,6.276c-.1.755-.07,1.349-.1,1.749-.017.4-.037.612-.037.612a21.618,21.618,0,0,1,.06-2.368,25.527,25.527,0,0,1,1.327-6.317,37.823,37.823,0,0,1,4.275-8.565,72.182,72.182,0,0,1,7.3-9.184c2.827-3.056,5.612-5.876,8.034-8.544a74.123,74.123,0,0,0,6.041-7.409,42.094,42.094,0,0,0,3.314-5.525c.359-.673.568-1.228.746-1.587S352.2,222.257,352.2,222.257Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M306.138,239.487s.114-.091.34-.248c.279-.19.607-.412.995-.677.873-.574,2.1-1.456,3.584-2.592s3.188-2.564,5-4.237a69.388,69.388,0,0,0,10.395-12.2c1.364-2.057,2.511-3.964,3.391-5.611s1.563-3,1.992-3.949l.51-1.09c.119-.248.191-.374.191-.374A53.951,53.951,0,0,1,329.976,214c-.866,1.659-2,3.579-3.361,5.648a67.217,67.217,0,0,1-10.425,12.23c-1.826,1.67-3.542,3.1-5.044,4.213A53.884,53.884,0,0,1,306.138,239.487Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4751",
    "data-name": "Group 4751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M234.67,286.251a1.059,1.059,0,0,1,.241-.112l.722-.278c.643-.218,1.559-.624,2.727-1.164a35.969,35.969,0,0,0,8.85-6.293,70.143,70.143,0,0,0,10.132-12.57,178.048,178.048,0,0,0,9.874-17.2,298.953,298.953,0,0,0,14.019-33.221c1.577-4.341,2.8-7.874,3.655-10.312.419-1.191.749-2.129.988-2.806.109-.3.2-.536.269-.726a1.054,1.054,0,0,1,.107-.242,1.009,1.009,0,0,1-.059.258l-.222.741c-.216.685-.517,1.634-.9,2.837-.8,2.458-1.971,6.009-3.506,10.369a278.044,278.044,0,0,1-13.906,33.328,172.308,172.308,0,0,1-9.935,17.232,68.9,68.9,0,0,1-10.276,12.575,34.851,34.851,0,0,1-9.008,6.21,25.544,25.544,0,0,1-2.778,1.083l-.739.232A1.041,1.041,0,0,1,234.67,286.251Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M232.995,307.41a3.457,3.457,0,0,1,.547-.416l1.614-1.116c1.4-.975,3.407-2.4,5.823-4.257,4.851-3.686,11.217-9.2,18.065-15.491,3.434-3.141,6.724-6.109,9.569-8.955a74.053,74.053,0,0,0,7.055-8.006,44.3,44.3,0,0,0,3.861-6.066c.418-.742.679-1.35.885-1.748a3.493,3.493,0,0,1,.329-.6,3.526,3.526,0,0,1-.236.644c-.177.413-.411,1.036-.8,1.8a39.922,39.922,0,0,1-3.75,6.188,70.386,70.386,0,0,1-7.013,8.122c-2.839,2.876-6.125,5.859-9.558,9a236.992,236.992,0,0,1-18.189,15.4c-2.449,1.823-4.495,3.21-5.928,4.137-.716.465-1.285.8-1.669,1.039A3.6,3.6,0,0,1,232.995,307.41Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4756",
    "data-name": "Group 4756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M206.014,414.318a.981.981,0,0,1,.119-.225c.1-.168.234-.376.394-.635.352-.553.892-1.357,1.613-2.374,1.449-2.029,3.68-4.872,6.624-8.218,5.925-6.656,14.229-15.727,23.377-25.774l23.513-25.656,7.167-7.736,1.968-2.086.521-.534a.968.968,0,0,1,.19-.17,1,1,0,0,1-.152.2c-.128.151-.288.337-.485.568l-1.9,2.15-7.049,7.843c-6.013,6.616-14.275,15.708-23.4,25.755-9.159,10.011-17.45,19.075-23.483,25.671-2.973,3.31-5.238,6.109-6.732,8.1-.743,1-1.308,1.781-1.686,2.316l-.435.606A.967.967,0,0,1,206.014,414.318Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4759",
    "data-name": "Group 4759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4758",
    "data-name": "Group 4758"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M299.364,234.591a9.345,9.345,0,0,1-.377-1.521,17.633,17.633,0,0,1-.318-1.811c-.093-.711-.235-1.518-.281-2.421-.076-.9-.148-1.889-.142-2.952-.041-1.064.03-2.2.083-3.394a43.729,43.729,0,0,1,3.74-15.029c.514-1.08.983-2.116,1.518-3.036.493-.943,1.02-1.782,1.509-2.542.464-.776.968-1.422,1.383-2.006a17.645,17.645,0,0,1,1.13-1.451,9.5,9.5,0,0,1,1.045-1.167,9.282,9.282,0,0,1-.891,1.287c-.3.4-.67.892-1.055,1.493s-.871,1.251-1.312,2.032c-.466.766-.971,1.608-1.443,2.55-.514.92-.964,1.952-1.461,3.027a45.84,45.84,0,0,0-3.7,14.876c-.064,1.181-.151,2.3-.127,3.358-.025,1.054.027,2.033.079,2.928.023.9.14,1.7.206,2.411s.15,1.318.233,1.813A9.582,9.582,0,0,1,299.364,234.591Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4761",
    "data-name": "Group 4761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4760",
    "data-name": "Group 4760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M313.914,270.467a94.527,94.527,0,0,1-4.02-8.878,94.506,94.506,0,0,1-3.559-9.074,95.09,95.09,0,0,1,4.02,8.879A95.085,95.085,0,0,1,313.914,270.467Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4763",
    "data-name": "Group 4763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4762",
    "data-name": "Group 4762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M170.957,238.765c-.077.042-.855-1.389-2.327-3.557a49.975,49.975,0,0,0-14.575-14.146c-2.211-1.406-3.665-2.14-3.625-2.219a5.041,5.041,0,0,1,1.059.44c.671.307,1.615.808,2.752,1.478a44.307,44.307,0,0,1,14.685,14.252c.7,1.116,1.233,2.045,1.559,2.707A5.086,5.086,0,0,1,170.957,238.765Z",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4783",
    "data-name": "Group 4783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4768",
    "data-name": "Group 4768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M210.247,215.12a3.321,3.321,0,0,1-.01-1.03,8.088,8.088,0,0,1,.609-2.413,7.883,7.883,0,0,1,1.684-2.539l.056-.054.028.067a1.546,1.546,0,0,1,.153.439,1.554,1.554,0,0,1-.246-.395l.084.013a10.023,10.023,0,0,0-1.567,2.549A12.642,12.642,0,0,0,210.247,215.12Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M223.486,221.981a3.486,3.486,0,0,1-.2-1,9.4,9.4,0,0,1,.75-4.82,3.435,3.435,0,0,1,.5-.888,12.507,12.507,0,0,0-1.043,6.705Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4772",
    "data-name": "Group 4772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4771",
    "data-name": "Group 4771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M237.92,220.841a10.839,10.839,0,0,0-1.467-5.361,2.471,2.471,0,0,1,.5.671,7.615,7.615,0,0,1,1.056,3.859A2.46,2.46,0,0,1,237.92,220.841Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4774",
    "data-name": "Group 4774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4773",
    "data-name": "Group 4773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M250.538,215.312a11.389,11.389,0,0,0-3.6-4.611,2.691,2.691,0,0,1,.752.454,8.089,8.089,0,0,1,2.591,3.317A2.727,2.727,0,0,1,250.538,215.312Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4776",
    "data-name": "Group 4776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4775",
    "data-name": "Group 4775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M259.229,206.742a5.566,5.566,0,0,0-4.674-4.035c0-.014.093-.02.263-.018a3.4,3.4,0,0,1,.714.093,4.985,4.985,0,0,1,3.48,3,3.4,3.4,0,0,1,.2.692C259.235,206.646,259.243,206.739,259.229,206.742Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4778",
    "data-name": "Group 4778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4777",
    "data-name": "Group 4777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M263.877,190.908a5.6,5.6,0,0,0-5.538-1.021,4.584,4.584,0,0,1,5.538,1.021Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4780",
    "data-name": "Group 4780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4779",
    "data-name": "Group 4779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M201.569,204.451a2.372,2.372,0,0,1,.21-.856,5.746,5.746,0,0,1,2.834-3.082,2.4,2.4,0,0,1,.836-.281,7.026,7.026,0,0,0-3.88,4.219Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4782",
    "data-name": "Group 4782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4781",
    "data-name": "Group 4781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M198.409,193.913a2.89,2.89,0,0,1,.5-.808,7.332,7.332,0,0,1,3.749-2.535,2.9,2.9,0,0,1,.935-.161,9.33,9.33,0,0,0-5.181,3.5Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4785",
    "data-name": "Group 4785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4784",
    "data-name": "Group 4784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M173.553,255.366c-.007.014-.045-.053-.067.01a1.368,1.368,0,0,0-.082.328c-.051.3-.107.757-.165,1.343-.115,1.173-.249,2.876-.391,4.981-.287,4.211-.617,10.035-.93,16.469s-.545,12.265-.688,16.485c-.067,2.047-.122,3.734-.164,5-.022.54-.041.988-.056,1.359a1.64,1.64,0,0,1-.053.474,1.669,1.669,0,0,1-.052-.474c-.011-.372-.025-.821-.041-1.36-.022-1.182-.027-2.892,0-5.005.049-4.225.223-10.06.536-16.5s.7-12.263,1.083-16.473c.19-2.1.379-3.806.557-4.977a12.122,12.122,0,0,1,.264-1.342,1.006,1.006,0,0,1,.143-.338C173.543,255.254,173.566,255.389,173.553,255.366Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4971",
    "data-name": "Group 4971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4931",
    "data-name": "Group 4931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4788",
    "data-name": "Group 4788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4787",
    "data-name": "Group 4787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M283.727,53.385c-8.342-2.551-17.035,4.915-25.6,3.238-5.2-1.018-9.123-5.171-13.747-7.754-6.915-3.863-16.694-4.486-23.756-.9s-11.615,7.415-12.577,15.277c-6.428-3.689-17.153,4.4-20.806,12.21s-2.735,15.88-.662,24.246A113.741,113.741,0,0,0,205.4,139.74c.781,1.058,2.026,2.228,3.216,1.669a2.871,2.871,0,0,0,1.236-2.306c1.229-7.652.259-15.46-.4-23.181s-.987-15.682,1.451-23.038,8.193-14.067,15.8-15.568c5.615-1.11,11.449.718,16.441,3.52s9.378,6.551,14.132,9.741,10.09,5.878,15.809,6.127,11.853-2.448,14.29-7.628-.3-12.539-5.9-13.726a11.252,11.252,0,0,0,2.26-21.965Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4905",
    "data-name": "Group 4905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4904",
    "data-name": "Group 4904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4903",
    "data-name": "Group 4903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4811",
    "data-name": "Group 4811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4810",
    "data-name": "Group 4810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4809",
    "data-name": "Group 4809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4798",
    "data-name": "Group 4798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4797",
    "data-name": "Group 4797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4796",
    "data-name": "Group 4796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4795",
    "data-name": "Group 4795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4794",
    "data-name": "Group 4794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4793",
    "data-name": "Group 4793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4792",
    "data-name": "Group 4792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4791",
    "data-name": "Group 4791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4790",
    "data-name": "Group 4790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4789",
    "data-name": "Group 4789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M258,187.533l-.808-16.559s21.823-4.182,21.324-26.13c-.24-10.6-2.512-32.38-4.8-52.072A40.907,40.907,0,0,0,231.651,56.6l-2.117.074c-22.779,2.134-33.692,22.672-30.928,45.382l5.252,88.406a27.11,27.11,0,0,0,28.5,25.465h0A27.111,27.111,0,0,0,258,187.533Z",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4808",
    "data-name": "Group 4808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4807",
    "data-name": "Group 4807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4806",
    "data-name": "Group 4806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4805",
    "data-name": "Group 4805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4804",
    "data-name": "Group 4804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4803",
    "data-name": "Group 4803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4802",
    "data-name": "Group 4802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4801",
    "data-name": "Group 4801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4800",
    "data-name": "Group 4800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4799",
    "data-name": "Group 4799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M257.217,170.959s-13.825,1.614-28.886-7.125c0,0,7.314,15.551,29.136,12.808Z",
    fill: "#eb996e"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4902",
    "data-name": "Group 4902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4901",
    "data-name": "Group 4901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4880",
    "data-name": "Group 4880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4879",
    "data-name": "Group 4879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4878",
    "data-name": "Group 4878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    "data-name": "Group 4833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4821",
    "data-name": "Group 4821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4820",
    "data-name": "Group 4820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4819",
    "data-name": "Group 4819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4818",
    "data-name": "Group 4818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4817",
    "data-name": "Group 4817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4816",
    "data-name": "Group 4816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4815",
    "data-name": "Group 4815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4814",
    "data-name": "Group 4814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4813",
    "data-name": "Group 4813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4812",
    "data-name": "Group 4812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M266.326,107.647a3.135,3.135,0,0,1-2.91,3.267,3,3,0,0,1-3.329-2.712,3.136,3.136,0,0,1,2.907-3.268A3,3,0,0,1,266.326,107.647Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4832",
    "data-name": "Group 4832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4831",
    "data-name": "Group 4831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    "data-name": "Group 4830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4829",
    "data-name": "Group 4829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    "data-name": "Group 4828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4827",
    "data-name": "Group 4827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4826",
    "data-name": "Group 4826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4825",
    "data-name": "Group 4825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4824",
    "data-name": "Group 4824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4823",
    "data-name": "Group 4823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4822",
    "data-name": "Group 4822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M269.378,103.661c-.374.422-2.808-1.251-6.18-1.124-3.369.079-5.782,1.9-6.162,1.5-.187-.176.183-.928,1.233-1.75a8.6,8.6,0,0,1,4.916-1.706,8.259,8.259,0,0,1,4.937,1.4C269.186,102.745,269.564,103.471,269.378,103.661Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4855",
    "data-name": "Group 4855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4843",
    "data-name": "Group 4843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4841",
    "data-name": "Group 4841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    "data-name": "Group 4840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4839",
    "data-name": "Group 4839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4838",
    "data-name": "Group 4838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4837",
    "data-name": "Group 4837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    "data-name": "Group 4836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4835",
    "data-name": "Group 4835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4834",
    "data-name": "Group 4834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M233.208,109.952a3.136,3.136,0,0,1-2.91,3.267,3,3,0,0,1-3.329-2.712,3.136,3.136,0,0,1,2.907-3.268A3,3,0,0,1,233.208,109.952Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4854",
    "data-name": "Group 4854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4853",
    "data-name": "Group 4853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4852",
    "data-name": "Group 4852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4851",
    "data-name": "Group 4851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4850",
    "data-name": "Group 4850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4849",
    "data-name": "Group 4849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4848",
    "data-name": "Group 4848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4847",
    "data-name": "Group 4847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4846",
    "data-name": "Group 4846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    "data-name": "Group 4845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4844",
    "data-name": "Group 4844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M236.262,105.452c-.375.422-2.813-1.25-6.182-1.123-3.369.079-5.783,1.9-6.163,1.5-.185-.176.181-.927,1.235-1.749a8.591,8.591,0,0,1,4.915-1.707,8.265,8.265,0,0,1,4.938,1.4C236.066,104.536,236.445,105.263,236.262,105.452Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4866",
    "data-name": "Group 4866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4865",
    "data-name": "Group 4865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4864",
    "data-name": "Group 4864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4863",
    "data-name": "Group 4863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4862",
    "data-name": "Group 4862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4861",
    "data-name": "Group 4861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4860",
    "data-name": "Group 4860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4859",
    "data-name": "Group 4859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4858",
    "data-name": "Group 4858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4857",
    "data-name": "Group 4857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4856",
    "data-name": "Group 4856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M249.374,130.026c-.023-.191,2.06-.627,5.441-1.18.857-.119,1.666-.319,1.791-.912a4.386,4.386,0,0,0-.664-2.531q-1.324-3.083-2.776-6.466c-3.863-9.21-6.691-16.794-6.32-16.947s3.806,7.189,7.669,16.4q1.4,3.408,2.67,6.509a4.989,4.989,0,0,1,.565,3.364,2.163,2.163,0,0,1-1.371,1.308,5.862,5.862,0,0,1-1.455.255C251.513,130.127,249.394,130.217,249.374,130.026Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4877",
    "data-name": "Group 4877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4876",
    "data-name": "Group 4876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4875",
    "data-name": "Group 4875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4874",
    "data-name": "Group 4874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4873",
    "data-name": "Group 4873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4872",
    "data-name": "Group 4872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4871",
    "data-name": "Group 4871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4870",
    "data-name": "Group 4870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4869",
    "data-name": "Group 4869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4868",
    "data-name": "Group 4868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4867",
    "data-name": "Group 4867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M239.534,132.706c.547-.051.682,3.608,3.9,6.1s7.105,1.949,7.152,2.46c.059.227-.844.741-2.489.843a9.12,9.12,0,0,1-5.962-1.845,7.947,7.947,0,0,1-3.041-5.12C238.906,133.614,239.282,132.693,239.534,132.706Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4890",
    "data-name": "Group 4890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4889",
    "data-name": "Group 4889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4888",
    "data-name": "Group 4888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4887",
    "data-name": "Group 4887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4886",
    "data-name": "Group 4886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4885",
    "data-name": "Group 4885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4884",
    "data-name": "Group 4884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4883",
    "data-name": "Group 4883"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4882",
    "data-name": "Group 4882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4881",
    "data-name": "Group 4881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M235.991,88.166c-.3.928-3.682.612-7.62,1.227-3.952.537-7.1,1.806-7.654,1-.248-.386.278-1.267,1.536-2.2a13.422,13.422,0,0,1,11.637-1.7C235.362,87.031,236.119,87.726,235.991,88.166Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4900",
    "data-name": "Group 4900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4899",
    "data-name": "Group 4899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4898",
    "data-name": "Group 4898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4897",
    "data-name": "Group 4897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4896",
    "data-name": "Group 4896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4895",
    "data-name": "Group 4895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4894",
    "data-name": "Group 4894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4893",
    "data-name": "Group 4893"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4892",
    "data-name": "Group 4892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4891",
    "data-name": "Group 4891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M267.8,93.947c-.566.787-2.917.073-5.711.134-2.8-.037-5.139.695-5.712-.087-.252-.38.093-1.16,1.1-1.921a8.274,8.274,0,0,1,9.2-.038C267.694,92.787,268.045,93.565,267.8,93.947Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4927",
    "data-name": "Group 4927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4915",
    "data-name": "Group 4915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4914",
    "data-name": "Group 4914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4913",
    "data-name": "Group 4913"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4912",
    "data-name": "Group 4912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4911",
    "data-name": "Group 4911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4910",
    "data-name": "Group 4910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4909",
    "data-name": "Group 4909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4908",
    "data-name": "Group 4908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4907",
    "data-name": "Group 4907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4906",
    "data-name": "Group 4906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M200.967,118.238c-.38-.148-15.23-3.93-14.225,11.052s15.839,10.883,15.836,10.451S200.967,118.238,200.967,118.238Z",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4926",
    "data-name": "Group 4926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4925",
    "data-name": "Group 4925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4924",
    "data-name": "Group 4924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4923",
    "data-name": "Group 4923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4922",
    "data-name": "Group 4922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4921",
    "data-name": "Group 4921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4920",
    "data-name": "Group 4920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4919",
    "data-name": "Group 4919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4918",
    "data-name": "Group 4918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4917",
    "data-name": "Group 4917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4916",
    "data-name": "Group 4916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M197.621,134.372c-.069-.043-.249.2-.677.432a2.612,2.612,0,0,1-1.948.171c-1.621-.474-3.123-2.9-3.377-5.593a8.662,8.662,0,0,1,.48-3.786,3.022,3.022,0,0,1,1.829-2.135,1.332,1.332,0,0,1,1.588.612c.229.406.154.711.235.731.045.035.3-.272.143-.883a1.672,1.672,0,0,0-.653-.9,1.977,1.977,0,0,0-1.469-.285,3.676,3.676,0,0,0-2.57,2.506,8.876,8.876,0,0,0-.625,4.237c.3,3.012,2.034,5.733,4.241,6.214a2.8,2.8,0,0,0,2.361-.556C197.618,134.736,197.675,134.4,197.621,134.372Z",
    fill: "#eb996e"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4930",
    "data-name": "Group 4930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4929",
    "data-name": "Group 4929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4928",
    "data-name": "Group 4928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M278.2,88.01a31.7,31.7,0,0,1-28.37-5.353c-5.495-4.338-9.841-10.7-16.6-12.522-4.551-1.228-9.518-.081-13.562,2.342a34.437,34.437,0,0,0-10,9.857c4.629,11,2.218,23.546-.262,35.221a5.967,5.967,0,0,1-1.625,3.521c-1.726,1.427-4.42.454-6.024-1.11-2.566-2.5-3.655-6.132-4.412-9.637A61.749,61.749,0,0,1,196.638,86a42.033,42.033,0,0,1,10.8-21.607A39.817,39.817,0,0,1,234.98,52.861a48.9,48.9,0,0,1,28.7,9.14c3.877,2.72,7.478,6.045,9.583,10.288",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4934",
    "data-name": "Group 4934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4933",
    "data-name": "Group 4933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4932",
    "data-name": "Group 4932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M290.211,58.45a3.221,3.221,0,0,1-.089,1.305,6.089,6.089,0,0,1-1.988,3.166,9.554,9.554,0,0,1-5.539,2.066,16,16,0,0,1-3.73-.1,7.984,7.984,0,0,1-3.884-1.637,5.3,5.3,0,0,1-2.023-4.169,4.665,4.665,0,0,1,3.051-3.941A5.769,5.769,0,0,1,278.7,54.7a4.9,4.9,0,0,1,2.616,1.066,6.823,6.823,0,0,1,2.418,5.166,7.909,7.909,0,0,1-2.172,5.586,12.042,12.042,0,0,1-5.326,3.274c-4.119,1.29-8.722.661-12.865-.945a56.468,56.468,0,0,1-11.326-6.29,71.68,71.68,0,0,0-10.286-6.07,22.233,22.233,0,0,0-10.393-2.146,21.255,21.255,0,0,0-8.893,2.619,26.555,26.555,0,0,0-9.634,9.393,34.7,34.7,0,0,0-1.794,3.254,10.247,10.247,0,0,1-.589,1.16,1.174,1.174,0,0,1,.1-.319c.077-.2.186-.513.358-.9a27.973,27.973,0,0,1,1.682-3.341,26.237,26.237,0,0,1,9.627-9.7,21.653,21.653,0,0,1,9.109-2.775,22.769,22.769,0,0,1,10.71,2.135,71.233,71.233,0,0,1,10.411,6.09,56.364,56.364,0,0,0,11.187,6.2c4.051,1.569,8.468,2.161,12.386.943a11.341,11.341,0,0,0,5.016-3.056,7.208,7.208,0,0,0,2.012-5.089,6.171,6.171,0,0,0-2.139-4.672,4.517,4.517,0,0,0-4.66-.569,4.074,4.074,0,0,0-2.713,3.4,4.762,4.762,0,0,0,1.788,3.74,7.525,7.525,0,0,0,3.623,1.572,15.755,15.755,0,0,0,3.62.151,9.344,9.344,0,0,0,5.384-1.872,6.138,6.138,0,0,0,2.03-2.983A10.284,10.284,0,0,0,290.211,58.45Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4937",
    "data-name": "Group 4937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4936",
    "data-name": "Group 4936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4935",
    "data-name": "Group 4935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M185.027,88.467a24.715,24.715,0,0,0,4.622,1.029,12.9,12.9,0,0,0,5.008-.7,21.658,21.658,0,0,0,5.529-2.9,17.536,17.536,0,0,0,6.369-9.17,35.908,35.908,0,0,0,.834-4.681,3.845,3.845,0,0,1,.124,1.295,14.9,14.9,0,0,1-.45,3.523,17.113,17.113,0,0,1-6.439,9.634,21.015,21.015,0,0,1-5.756,2.955,12.714,12.714,0,0,1-5.264.57,11.867,11.867,0,0,1-3.44-.918A3.769,3.769,0,0,1,185.027,88.467Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4940",
    "data-name": "Group 4940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4939",
    "data-name": "Group 4939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4938",
    "data-name": "Group 4938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M186.063,99.3c.016-.137,1.78.191,4.6-.067a20.589,20.589,0,0,0,17.1-12.184c1.166-2.585,1.432-4.359,1.567-4.329a3.668,3.668,0,0,1-.116,1.25,17.1,17.1,0,0,1-.967,3.285,19.871,19.871,0,0,1-17.543,12.5,17.16,17.16,0,0,1-3.421-.158A3.645,3.645,0,0,1,186.063,99.3Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4943",
    "data-name": "Group 4943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4942",
    "data-name": "Group 4942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4941",
    "data-name": "Group 4941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M225.562,120.179a.409.409,0,1,1,.268-.482A.392.392,0,0,1,225.562,120.179Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4946",
    "data-name": "Group 4946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4945",
    "data-name": "Group 4945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4944",
    "data-name": "Group 4944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M231.952,118.492a.479.479,0,1,1,.255-.54A.427.427,0,0,1,231.952,118.492Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4949",
    "data-name": "Group 4949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4948",
    "data-name": "Group 4948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4947",
    "data-name": "Group 4947"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M236.286,118.232c-.2.033-.411-.209-.464-.541s.067-.627.27-.66.41.21.464.542S236.488,118.2,236.286,118.232Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4952",
    "data-name": "Group 4952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4951",
    "data-name": "Group 4951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4950",
    "data-name": "Group 4950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M228.871,124.111c-.206.007-.376-.094-.381-.225s.159-.244.364-.251.375.094.38.225S229.076,124.1,228.871,124.111Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4955",
    "data-name": "Group 4955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4954",
    "data-name": "Group 4954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M234.73,122.533a.426.426,0,1,1,.318-.465A.4.4,0,0,1,234.73,122.533Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4957",
    "data-name": "Group 4957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4956",
    "data-name": "Group 4956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M265.345,117.784a.423.423,0,1,1,.266-.494A.4.4,0,0,1,265.345,117.784Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4961",
    "data-name": "Group 4961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4960",
    "data-name": "Group 4960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4959",
    "data-name": "Group 4959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M269.721,117.229a.482.482,0,1,1,.306-.514A.429.429,0,0,1,269.721,117.229Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4963",
    "data-name": "Group 4963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4962",
    "data-name": "Group 4962"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M261.472,118.029a.329.329,0,1,1,.287-.4A.351.351,0,0,1,261.472,118.029Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4967",
    "data-name": "Group 4967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M264.88,122.305a.434.434,0,1,1,.148-.549A.4.4,0,0,1,264.88,122.305Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4970",
    "data-name": "Group 4970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4969",
    "data-name": "Group 4969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4968",
    "data-name": "Group 4968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M268.6,121.425a.318.318,0,1,1,.434-.22A.348.348,0,0,1,268.6,121.425Z",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5047",
    "data-name": "Group 5047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5034",
    "data-name": "Group 5034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4972",
    "data-name": "Group 4972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M261.178,370.637l-.236-22.228s-14.835-20.549-8.981-42.841c0,0,9.672-6.8,35.6-2.814,0,0,32.551-31.711,76.183-23.648s47.689,46.085,48.1,56.434.324,30.448-14.693,50.1l-1.011,19.5s-3.577,7.347-13.935,6.848-9.766-2.028-9.766-2.028-12.983,10.491-13.563,13.238-2.6,13.122-2.6,13.122-4.5,6.138-14.24,6.85a21,21,0,0,1-11.123-2.28,10.979,10.979,0,0,1-5.509-6.463,22.817,22.817,0,0,0-12.235-14.093l-6.718-1.756s-2.714,2.465-12.144,3.478-9.464-2.335-9.464-2.335-14.669,3.392-25.7-10.994C250.437,397.36,245.714,376.891,261.178,370.637Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4974",
    "data-name": "Group 4974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4973",
    "data-name": "Group 4973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M351.625,371.921a5,5,0,0,1,.48-.685c.331-.437.824-1.075,1.433-1.917,1.228-1.674,2.956-4.136,4.852-7.326a84.408,84.408,0,0,0,5.737-11.682c.909-2.276,1.758-4.708,2.514-7.264.734-2.53,1.376-5.308.716-8.015a11.389,11.389,0,0,0-4.8-6.306,34.035,34.035,0,0,0-6.779-3.521,45.106,45.106,0,0,0-12.6-3.03,45.974,45.974,0,0,0-8.764,0c-1.033.1-1.833.2-2.374.278a5.216,5.216,0,0,1-.832.083,4.865,4.865,0,0,1,.815-.187c.537-.115,1.335-.246,2.369-.376a42.813,42.813,0,0,1,8.818-.167,44.455,44.455,0,0,1,12.741,2.951,34.141,34.141,0,0,1,6.9,3.55,11.858,11.858,0,0,1,5.011,6.6c.7,2.877.011,5.735-.731,8.285-.768,2.572-1.632,5.014-2.559,7.3a80.963,80.963,0,0,1-5.866,11.693,77.986,77.986,0,0,1-5.006,7.26c-.636.824-1.156,1.444-1.513,1.86A5.035,5.035,0,0,1,351.625,371.921Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4976",
    "data-name": "Group 4976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4975",
    "data-name": "Group 4975"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M290.617,303.717a1.7,1.7,0,0,1,.154.517,5.409,5.409,0,0,1,.067,1.548,8.73,8.73,0,0,1-2.494,5.049c-1.637,1.8-4.116,3.269-6.533,5.249a55.411,55.411,0,0,0-7.31,7.087,58.075,58.075,0,0,0-9.623,15.745c-.894,2.2-1.491,4.028-1.884,5.3-.177.59-.322,1.075-.439,1.467a2.11,2.11,0,0,1-.188.5,2.068,2.068,0,0,1,.086-.529c.092-.4.206-.9.346-1.5a50.189,50.189,0,0,1,1.737-5.379,55.311,55.311,0,0,1,9.57-15.949,53.534,53.534,0,0,1,7.406-7.122c2.469-1.985,4.946-3.41,6.566-5.128a7.657,7.657,0,0,0,2.539-6.86Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4977",
    "data-name": "Group 4977",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M308.056,306.441l13.273,3.389s19.434-21.841,40.775-27.363l-7.994-1.885A92.319,92.319,0,0,0,308.056,306.441Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4978",
    "data-name": "Group 4978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M357.772,281.425a89.709,89.709,0,0,0-45.6,26.032l-4.12-1.016s18.824-20.655,46.054-25.859Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4980",
    "data-name": "Group 4980",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4979",
    "data-name": "Group 4979"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M357.772,281.425a89.709,89.709,0,0,0-45.6,26.032l-4.12-1.016s18.824-20.655,46.054-25.859Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4981",
    "data-name": "Group 4981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M254.767,375.174c7.358-10.524,25.788-7.309,34.2,2.158,8.289,9.328,12.146,22.482,6.672,33.7-2.337,4.788-6.819,9.015-12.146,8.9a25.009,25.009,0,0,0,5.7-22.246c-1.712-7.855-6.656-14.777-12.916-19.821-3.175-2.559-6.741-5.371-10.8-5.774s-7.317-.518-10.707,3.088",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4983",
    "data-name": "Group 4983",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4982",
    "data-name": "Group 4982"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M254.767,375.174c7.358-10.524,25.788-7.309,34.2,2.158,8.289,9.328,12.146,22.482,6.672,33.7-2.337,4.788-6.819,9.015-12.146,8.9a25.009,25.009,0,0,0,5.7-22.246c-1.712-7.855-6.656-14.777-12.916-19.821-3.175-2.559-6.741-5.371-10.8-5.774s-7.317-.518-10.707,3.088"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4985",
    "data-name": "Group 4985",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4984",
    "data-name": "Group 4984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M352.358,371.3a4.577,4.577,0,0,0,4.112,4.458,7.057,7.057,0,0,0,5.889-2.581,16.218,16.218,0,0,0,3-5.922c2.3-7.205,3.486-17.961,2.283-25.427-3.182,9.673-8.864,21.73-15.454,29.493"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4987",
    "data-name": "Group 4987",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4986",
    "data-name": "Group 4986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M359.329,338.046c-1.431-4.231-5.809-6.691-10.027-8.16a48.371,48.371,0,0,0-13.335-2.62,10.6,10.6,0,0,0-4.245.416,4.2,4.2,0,0,0-2.795,3,2.811,2.811,0,0,0,1.422,2.9,79.2,79.2,0,0,1,15.87,28.817,2.7,2.7,0,0,0,4.639.992c3.4-3.876,5.362-9.106,7.121-14.069C359.268,345.685,360.566,341.7,359.329,338.046Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4989",
    "data-name": "Group 4989",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4988",
    "data-name": "Group 4988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M263.717,340a42.345,42.345,0,0,1-6.732-23.741c.038-1.765.254-3.685,1.487-4.949,1.492-1.531,3.906-1.559,6.04-1.425A115,115,0,0,1,282,312.348c.45.1.963.252,1.14.677a1.727,1.727,0,0,1-.392,2.012c-8.954,5.491-15.3,15.591-18.685,25.474"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4991",
    "data-name": "Group 4991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4990",
    "data-name": "Group 4990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M252.569,306.362a8.492,8.492,0,0,1-.067,1.51c-.087.966-.173,2.368-.235,4.1a66.828,66.828,0,0,0,.879,13.47,64.536,64.536,0,0,0,1.726,7.234,59.931,59.931,0,0,0,2.071,5.713c.675,1.593,1.263,2.869,1.7,3.733a8.388,8.388,0,0,1,.62,1.379,8.456,8.456,0,0,1-.8-1.284c-.5-.839-1.137-2.1-1.86-3.681a52.864,52.864,0,0,1-2.192-5.718,59.2,59.2,0,0,1-1.78-7.287,59.794,59.794,0,0,1-.734-13.576c.11-1.739.253-3.142.4-4.1A8.284,8.284,0,0,1,252.569,306.362Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4993",
    "data-name": "Group 4993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4992",
    "data-name": "Group 4992"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M353.326,279.861a2.252,2.252,0,0,1-.516.187l-1.5.438c-.655.18-1.455.4-2.372.7s-1.976.592-3.118,1c-2.3.764-5,1.8-7.952,3.054-2.936,1.289-6.112,2.823-9.345,4.623-3.223,1.821-6.189,3.731-8.82,5.564-2.613,1.858-4.9,3.625-6.754,5.192-.948.759-1.754,1.5-2.483,2.136s-1.342,1.192-1.836,1.657l-1.158,1.053a2.23,2.23,0,0,1-.429.343,2.145,2.145,0,0,1,.355-.417l1.091-1.125c.474-.489,1.065-1.076,1.781-1.727s1.505-1.421,2.44-2.2c1.83-1.608,4.105-3.413,6.715-5.3a94.36,94.36,0,0,1,18.254-10.236c2.974-1.241,5.7-2.24,8.027-2.963,1.153-.391,2.221-.667,3.15-.934s1.738-.469,2.4-.619l1.53-.344A2.11,2.11,0,0,1,353.326,279.861Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4995",
    "data-name": "Group 4995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4994",
    "data-name": "Group 4994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M364.987,332.7c-.077.086-1.589-1.448-4.488-3.3a35.85,35.85,0,0,0-5.336-2.791,41.464,41.464,0,0,0-7.03-2.217,43.148,43.148,0,0,0-13.342-.8c-3.423.349-5.492.92-5.517.812a8.259,8.259,0,0,1,1.442-.43,31.18,31.18,0,0,1,4.035-.748,40.316,40.316,0,0,1,13.494.66,39.477,39.477,0,0,1,7.106,2.285A33.255,33.255,0,0,1,360.7,329.1c.356.242.7.475,1.023.7l.867.686a13.827,13.827,0,0,1,1.343,1.147A8.252,8.252,0,0,1,364.987,332.7Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4997",
    "data-name": "Group 4997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4996",
    "data-name": "Group 4996"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M275.547,418.312a1.768,1.768,0,0,1-.478-.129c-.3-.107-.766-.241-1.333-.48a31.576,31.576,0,0,1-4.665-2.323,34.288,34.288,0,0,1-16.684-28.568,31.353,31.353,0,0,1,.269-5.205c.07-.611.18-1.078.236-1.4a1.755,1.755,0,0,1,.123-.48,17.249,17.249,0,0,1-.158,1.9,37.22,37.22,0,0,0-.1,5.168,35.037,35.037,0,0,0,16.509,28.268,37.2,37.2,0,0,0,4.552,2.45A17.2,17.2,0,0,1,275.547,418.312Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5003",
    "data-name": "Group 5003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4999",
    "data-name": "Group 4999",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4998",
    "data-name": "Group 4998"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M278.169,395.2a4.247,4.247,0,0,0-4.482,1.157,5.491,5.491,0,0,0-1.27,4.572,7.083,7.083,0,0,0,1.911,4.163,5.879,5.879,0,0,0,3.3,1.61,4.226,4.226,0,0,0,3.71-2.366,6.57,6.57,0,0,0-3.173-9.136"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5000",
    "data-name": "Group 5000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M276.624,395.019a6.652,6.652,0,0,0,3.55,10.721,3.864,3.864,0,0,1-3.367.893,6.9,6.9,0,0,1-4.7-7.125,5.27,5.27,0,0,1,1.447-3.375,4.554,4.554,0,0,1,3.067-1.114",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5002",
    "data-name": "Group 5002",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5001",
    "data-name": "Group 5001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M276.624,395.019a6.652,6.652,0,0,0,3.55,10.721,3.864,3.864,0,0,1-3.367.893,6.9,6.9,0,0,1-4.7-7.125,5.27,5.27,0,0,1,1.447-3.375,4.554,4.554,0,0,1,3.067-1.114"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5009",
    "data-name": "Group 5009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5005",
    "data-name": "Group 5005",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5004",
    "data-name": "Group 5004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M263.433,389.523a4.094,4.094,0,0,0-4.323,1.116,5.3,5.3,0,0,0-1.225,4.41,6.826,6.826,0,0,0,1.843,4.016,5.676,5.676,0,0,0,3.188,1.553,4.075,4.075,0,0,0,3.578-2.283,6.337,6.337,0,0,0-3.061-8.812"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5006",
    "data-name": "Group 5006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M261.943,389.343a6.416,6.416,0,0,0,3.424,10.342,3.726,3.726,0,0,1-3.247.861,6.655,6.655,0,0,1-4.531-6.873,5.081,5.081,0,0,1,1.4-3.255,4.4,4.4,0,0,1,2.959-1.075",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5008",
    "data-name": "Group 5008",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5007",
    "data-name": "Group 5007"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M261.943,389.343a6.416,6.416,0,0,0,3.424,10.342,3.726,3.726,0,0,1-3.247.861,6.655,6.655,0,0,1-4.531-6.873,5.081,5.081,0,0,1,1.4-3.255,4.4,4.4,0,0,1,2.959-1.075"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5014",
    "data-name": "Group 5014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5010",
    "data-name": "Group 5010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M303.192,361.378c.079-.013-.08.01,0,0Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5011",
    "data-name": "Group 5011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M301.371,361.951c.043-.029.1-.04.144-.066.023-.011.043-.027.066-.037Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5012",
    "data-name": "Group 5012"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M308.928,365.125a5.668,5.668,0,0,0-2.591-3.046,6.653,6.653,0,0,0-3.056-.71l-.089.009a3.9,3.9,0,0,0-1.677.507,7.243,7.243,0,0,0-4.005,5.85,8.007,8.007,0,0,0,4.6,7.591,4.191,4.191,0,0,0,5.638-1.343A9.02,9.02,0,0,0,308.928,365.125Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5019",
    "data-name": "Group 5019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5015",
    "data-name": "Group 5015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M272.04,351.772c.069-.012-.069.009,0,0Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5018",
    "data-name": "Group 5018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5016",
    "data-name": "Group 5016"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M270.463,352.268c.038-.025.085-.034.125-.057.019-.01.037-.023.057-.032Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5017",
    "data-name": "Group 5017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M277.009,355.017a4.91,4.91,0,0,0-2.245-2.638,5.775,5.775,0,0,0-2.647-.615l-.077.008a3.363,3.363,0,0,0-1.452.439,6.275,6.275,0,0,0-3.469,5.067,6.935,6.935,0,0,0,3.988,6.575,3.629,3.629,0,0,0,4.883-1.163A7.815,7.815,0,0,0,277.009,355.017Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5021",
    "data-name": "Group 5021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5020",
    "data-name": "Group 5020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M279.025,371.706a2.919,2.919,0,0,1,.623.128c.407.089.992.276,1.742.531a23.449,23.449,0,0,1,5.883,3.2,26.388,26.388,0,0,1,6.723,7.3,30.8,30.8,0,0,1,4.182,11.4,36.1,36.1,0,0,1-.139,12.156,18.276,18.276,0,0,1-4.147,8.982,12.25,12.25,0,0,1-5.618,3.6,6.851,6.851,0,0,1-2.433.332,16.975,16.975,0,0,0,2.374-.525,12.457,12.457,0,0,0,5.4-3.648,18.168,18.168,0,0,0,3.949-8.825,36.376,36.376,0,0,0,.1-11.985,30.848,30.848,0,0,0-4.075-11.231,26.606,26.606,0,0,0-6.537-7.256,24.923,24.923,0,0,0-5.735-3.3C279.858,371.974,279.011,371.759,279.025,371.706Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5023",
    "data-name": "Group 5023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5022",
    "data-name": "Group 5022"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M269.452,359.876c-.051.039-.31-.179-.577-.65a4.343,4.343,0,0,1-.013-4.063c.265-.472.522-.692.574-.654a6.71,6.71,0,0,0,.016,5.367Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5025",
    "data-name": "Group 5025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5024",
    "data-name": "Group 5024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M299.6,370.926c-.053.033-.3-.226-.523-.759a4.27,4.27,0,0,1,.708-4.231c.38-.432.7-.6.741-.547a6,6,0,0,0-.926,5.537Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5027",
    "data-name": "Group 5027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5026",
    "data-name": "Group 5026"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M318.571,423.773c-.053.076-1.264-.764-3.38-1.821a63.448,63.448,0,0,0-8.6-3.4c-3.442-1.124-6.59-2.075-8.834-2.876-1.122-.4-2.025-.738-2.636-1a3.909,3.909,0,0,1-.933-.454c.028-.074,1.416.409,3.685,1.108s5.424,1.6,8.882,2.732a50.9,50.9,0,0,1,8.6,3.57c.529.277.989.563,1.39.816a11.1,11.1,0,0,1,1.012.676A3.968,3.968,0,0,1,318.571,423.773Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5029",
    "data-name": "Group 5029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5028",
    "data-name": "Group 5028"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M389.518,391.562a10.369,10.369,0,0,1-.915,1.406c-.606.894-1.554,2.137-2.766,3.641a102.771,102.771,0,0,1-10.461,10.858c-4.363,3.959-8.434,7.39-11.312,9.95l-3.4,3.037a10.3,10.3,0,0,1-1.283,1.079,10.338,10.338,0,0,1,1.144-1.226c.756-.771,1.885-1.849,3.3-3.163,2.82-2.634,6.856-6.113,11.208-10.061a121.435,121.435,0,0,0,10.529-10.71c1.243-1.467,2.232-2.672,2.887-3.526A10.3,10.3,0,0,1,389.518,391.562Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5031",
    "data-name": "Group 5031",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5030",
    "data-name": "Group 5030"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M372.517,410.084c5.387.438,11.488-1.213,15.314-5.031a13.822,13.822,0,0,0,2.846-15.1c-3.137,4.478-6.678,9.241-11,12.9-2.725,2.308-4.528,5.116-7.164,7.236"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5033",
    "data-name": "Group 5033",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5032",
    "data-name": "Group 5032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M353.359,284.307c6.958,10.307,21.351,13.561,28.291,23.88,2.687,3.994,4.015,8.724,5.3,13.363q8.008,28.866,16.016,57.732c.664-12.511-2.352-24.892-5.346-37.057l-8.868-36.039a22.377,22.377,0,0,0-2.884-7.585c-1.578-2.269-3.926-3.862-6.22-5.4-8.216-5.516-16.676-11.14-26.324-13.339"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5036",
    "data-name": "Group 5036",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5035",
    "data-name": "Group 5035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M304.277,315.493c.44,1.4-1.475,3.306-4.469,5.677-1.508,1.177-3.272,2.526-5.211,3.978-1.923,1.482-4.011,3.084-6.164,4.818-2.138,1.756-4.132,3.475-5.975,5.055-1.816,1.6-3.5,3.056-4.955,4.293-2.932,2.449-5.186,3.936-6.469,3.219-1.225-.679-1.2-3.56.51-7.547a31.251,31.251,0,0,1,3.867-6.479,40.026,40.026,0,0,1,14.242-11.585,31.263,31.263,0,0,1,7.13-2.467C301.035,313.593,303.862,314.154,304.277,315.493Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5038",
    "data-name": "Group 5038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5037",
    "data-name": "Group 5037"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M277.527,394.414a643.38,643.38,0,0,1-4.537,1.074,5.526,5.526,0,0,1,4.537-1.074Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5040",
    "data-name": "Group 5040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5039",
    "data-name": "Group 5039"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M262.349,388.9a18.507,18.507,0,0,1-2.11.362,18.428,18.428,0,0,1-2.057.6c-.089-.1.7-.824,1.94-1.106A2.842,2.842,0,0,1,262.349,388.9Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5042",
    "data-name": "Group 5042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5041",
    "data-name": "Group 5041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M329.667,435.4c-.133.073-1.464-2.173-3.314-4.8s-3.5-4.643-3.391-4.744a30.254,30.254,0,0,1,6.7,9.541Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5044",
    "data-name": "Group 5044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5043",
    "data-name": "Group 5043"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M270.105,330.453c.134.09-1.835,2.975-3.547,6.9-1.736,3.912-2.532,7.313-2.69,7.274a8.3,8.3,0,0,1,.4-2.258,34.393,34.393,0,0,1,4.442-10.093A8.318,8.318,0,0,1,270.105,330.453Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5046",
    "data-name": "Group 5046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5045",
    "data-name": "Group 5045"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M318.584,311.092a30.216,30.216,0,0,1-10.859-3.8c.065-.137,2.427.888,5.419,1.929S318.618,310.944,318.584,311.092Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5062",
    "data-name": "Group 5062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5059",
    "data-name": "Group 5059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5058",
    "data-name": "Group 5058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5049",
    "data-name": "Group 5049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5048",
    "data-name": "Group 5048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M396.578,294.876a15.964,15.964,0,0,1-9.652,6.21,53.542,53.542,0,0,0,5.133-2.629A53.723,53.723,0,0,0,396.578,294.876Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5057",
    "data-name": "Group 5057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5050",
    "data-name": "Group 5050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M425.866,288.19c-5.373-12.4-59.121-56.418-59.121-56.418l-30.294,39.34c.434-.592,49.427,29.253,49.427,29.253l14.455,65.873h0l2.483,11.728s-6.5,5.671-6.231,11.658c.178,3.995-9.045,12.606-9.045,12.606-2.18-1.814-3.584-2.321-4.678-2.111l-9.75,9.127,2.322,2.12a13.464,13.464,0,0,0,9.49,3.514l16.67-.509a9.147,9.147,0,0,0,6.288-2.769c5.127-5.277,15.944-17.058,16.162-22.745.122-3.177.148-6.208.137-8.647C424.182,380.206,431.238,300.588,425.866,288.19Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5052",
    "data-name": "Group 5052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5051",
    "data-name": "Group 5051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M409.909,393.541a3.538,3.538,0,0,1-.924.594c-.617.343-1.56.744-2.647,1.341a11.681,11.681,0,0,0-3.271,2.818,18.617,18.617,0,0,1-3.98,3.715,15.577,15.577,0,0,1-9.438,2.6,5.136,5.136,0,0,1-1.715-.294,1.191,1.191,0,0,1-.8-1.061.881.881,0,0,1,.346-.772c.176-.1.288-.082.287-.071s-.1.039-.225.151a.808.808,0,0,0-.214.68.978.978,0,0,0,.717.814,5.123,5.123,0,0,0,1.621.2,15.968,15.968,0,0,0,9.146-2.663,19.083,19.083,0,0,0,3.914-3.606,11.494,11.494,0,0,1,3.447-2.821c1.137-.572,2.092-.918,2.73-1.2A6.738,6.738,0,0,1,409.909,393.541Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5054",
    "data-name": "Group 5054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5053",
    "data-name": "Group 5053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M402.288,402.221c.068.13-1.306.939-2.79,2.2s-2.518,2.472-2.635,2.383a10.471,10.471,0,0,1,5.425-4.584Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5056",
    "data-name": "Group 5056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5055",
    "data-name": "Group 5055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M409.029,374.931c.009.151-1.473.244-3.079,1.014-1.617.748-2.631,1.831-2.742,1.729a6.226,6.226,0,0,1,5.821-2.743Z",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5061",
    "data-name": "Group 5061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5060",
    "data-name": "Group 5060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M398.6,407.362c-.038.083-1.075-.431-2.865-.856a16.838,16.838,0,0,0-7.1-.142,16.093,16.093,0,0,0-1.963.529,7.5,7.5,0,0,1-.98.294,1.41,1.41,0,0,1-1.071-.227l-2.649-1.928a17.07,17.07,0,0,1-2.353-1.879,17.4,17.4,0,0,1,2.568,1.58l2.693,1.823c.431.332.97.086,1.626-.146a15.371,15.371,0,0,1,9.32-.261,13.321,13.321,0,0,1,2.076.788C398.369,407.18,398.616,407.331,398.6,407.362Z",
    fill: "#eb996e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5100",
    "data-name": "Group 5100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5063",
    "data-name": "Group 5063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M285.53,254.563c-6.41-1.831-9.254-2.628-9.254-2.628l.018-2.908,2.551-.029c2.55-.029,6.238-3.183,6.238-3.183l5.465-8.379.7-5.364c-.586-6.626-8.566-4.035-8.566-4.035-.375-2.311-10.594-4.632-18.272-6.057a17.678,17.678,0,0,0-14.635,3.858l-7.372,6.221L220.318,251.4l-57.006,48.151-37.468-11.064s-11.913,36.457-13.861,49.55c-3.733,25.092,30.753,41.811,45.955,28.9,11.819-10.039,80.761-84.275,92.18-96.589.03,0,.065,0,.1,0,7.03-.9,18.876-7.994,18.876-7.994l6.09.719s16.184,3.091,18.1-.084C294.779,260.495,291.939,256.394,285.53,254.563Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5099",
    "data-name": "Group 5099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5096",
    "data-name": "Group 5096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5075",
    "data-name": "Group 5075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5074",
    "data-name": "Group 5074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5065",
    "data-name": "Group 5065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5064",
    "data-name": "Group 5064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M252.338,247.278c.033-.014.158.236.357.7a12.8,12.8,0,0,1,.656,2.046,18.323,18.323,0,0,1-2.18,13.716,12.8,12.8,0,0,1-1.259,1.741c-.334.382-.53.581-.558.558-.073-.059.634-.925,1.5-2.485a20.082,20.082,0,0,0,2.139-13.452C252.654,248.354,252.249,247.311,252.338,247.278Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5067",
    "data-name": "Group 5067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5066",
    "data-name": "Group 5066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M256.466,226.864a2.949,2.949,0,0,1,.626-.119c.413-.057,1.022-.136,1.811-.21a28.086,28.086,0,0,1,6.713.079,16.094,16.094,0,0,1,4.47,1.332,12.106,12.106,0,0,1,4.258,3.261,8.731,8.731,0,0,1,2.047,5.548,6.841,6.841,0,0,1-.788,3.091,10.9,10.9,0,0,1-1.96,2.6,30.322,30.322,0,0,1-4.9,3.85,15.366,15.366,0,0,1-2.625,1.437,3.66,3.66,0,0,1-1.5.252,1.908,1.908,0,0,1-1.383-.7,2.226,2.226,0,0,1-.434-1.43,4.485,4.485,0,0,1,.255-1.371,9.647,9.647,0,0,1,1.172-2.313,9.794,9.794,0,0,1,3.439-3.088l.056.348-6.821-1.3-1.85-.379a3.049,3.049,0,0,1-.639-.168,3.076,3.076,0,0,1,.658.063l1.867.281,6.851,1.133.526.087-.47.261a9.488,9.488,0,0,0-3.257,3,9.257,9.257,0,0,0-1.1,2.214,2.6,2.6,0,0,0,.119,2.355,2,2,0,0,0,2.335.278,15.182,15.182,0,0,0,2.52-1.4,30.321,30.321,0,0,0,4.8-3.787,7.775,7.775,0,0,0,2.609-5.337,8.284,8.284,0,0,0-1.911-5.24,11.747,11.747,0,0,0-4.071-3.171,16,16,0,0,0-4.341-1.359,30.532,30.532,0,0,0-6.64-.24l-1.815.113A2.965,2.965,0,0,1,256.466,226.864Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5069",
    "data-name": "Group 5069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5068",
    "data-name": "Group 5068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M282.756,228.379a3.959,3.959,0,0,1,.178,1.078,25.883,25.883,0,0,1,.117,2.975,19.12,19.12,0,0,1-2.491,9.462c-1.991,3.345-5.134,5.508-7.719,5.843a3.245,3.245,0,0,1-2.819-.97,2.1,2.1,0,0,1-.424-.713c-.06-.18-.062-.281-.048-.285a4.236,4.236,0,0,0,.618.857,3.107,3.107,0,0,0,2.63.746c2.385-.4,5.4-2.518,7.316-5.747a20.047,20.047,0,0,0,2.569-9.207C282.806,229.933,282.667,228.385,282.756,228.379Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5071",
    "data-name": "Group 5071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5070",
    "data-name": "Group 5070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M268.607,256.936c-.056-.064.464-.518,1.079-1.412a8.125,8.125,0,0,0,.776-7.995c-.431-1-.854-1.54-.787-1.593a3.562,3.562,0,0,1,1.119,1.433,7.613,7.613,0,0,1-.813,8.376C269.257,256.624,268.641,256.983,268.607,256.936Z",
    fill: "#eb996e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5073",
    "data-name": "Group 5073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5072",
    "data-name": "Group 5072"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M258.889,237.982a3.282,3.282,0,0,1,.321,2.189,5.862,5.862,0,0,1-.7,2.334,11.02,11.02,0,0,1-1.7,2.423,12.512,12.512,0,0,1-4.492,2.874,8.38,8.38,0,0,1-2.086.693,10.32,10.32,0,0,1,1.934-1.029,14.231,14.231,0,0,0,4.264-2.9,11.817,11.817,0,0,0,1.662-2.3,6.01,6.01,0,0,0,.753-2.15A10.052,10.052,0,0,0,258.889,237.982Z",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5091",
    "data-name": "Group 5091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5076",
    "data-name": "Group 5076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M301.409,240.939l-28.126,15.335s15.048,3.76,28.666,18.175a82.844,82.844,0,0,1,17.122,27.232L347.1,283.035S332.049,248.9,301.409,240.939Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5078",
    "data-name": "Group 5078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5077",
    "data-name": "Group 5077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M278.24,255.7l22.714-12.981.065-.037.074.02a48.975,48.975,0,0,1,11.49,4.735,64.318,64.318,0,0,1,11.46,8.418,88.479,88.479,0,0,1,10.58,11.585,97.868,97.868,0,0,1,9.127,14.156l.106.2-.195.13-1.473.985L320.566,297.36l-.253.169-.115-.281a79.487,79.487,0,0,0-12.463-20.894,71.036,71.036,0,0,0-14.2-12.928A64.381,64.381,0,0,0,282.49,257.3c-1.357-.575-2.422-.97-3.146-1.226l-.828-.281c-.2-.068-.282-.1-.276-.1l.293.06.838.24c.734.23,1.812.6,3.183,1.153a61.825,61.825,0,0,1,11.152,6.018,70.426,70.426,0,0,1,14.354,12.913,79.351,79.351,0,0,1,12.6,20.977l-.368-.112L341.9,282.478l1.473-.985-.089.331a98.014,98.014,0,0,0-9.064-14.076,88.612,88.612,0,0,0-10.5-11.542,64.291,64.291,0,0,0-11.351-8.395A48.942,48.942,0,0,0,301,243.059l.138-.018Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5079",
    "data-name": "Group 5079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M324.287,264.937c-.733,4.329-6.218,6.95-12.252,5.853s-10.33-5.5-9.6-9.826,6.218-6.95,12.251-5.853S325.02,260.607,324.287,264.937Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5080",
    "data-name": "Group 5080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M311.184,266.333l-.972,1.075-1.122-1.089.938-1.036a7.2,7.2,0,0,1-1.7-3.036l1.887-.822a5.9,5.9,0,0,0,1.554,2.766c.766.745,1.266.813,1.564.484.972-1.075-3.456-3.906-1.177-6.424.964-1.065,2.517-1.249,4.206.03l.964-1.066,1.121,1.09-.946,1.046a6.493,6.493,0,0,1,1.378,2.415l-1.857.869a5.528,5.528,0,0,0-1.339-2.284c-.775-.754-1.3-.755-1.608-.416-.938,1.036,3.472,3.867,1.212,6.365C314.36,267.327,312.843,267.528,311.184,266.333Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5081",
    "data-name": "Group 5081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M284.66,252.09s4.767,2.42.187,5.956l-7.007-2.718Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5082",
    "data-name": "Group 5082"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M297.474,244.887s4.6,4.858,8.992-.2l-5.421-1.812Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5083",
    "data-name": "Group 5083"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M317.536,290.774s6.19-5.025,9.808,1.753l-6.916,4.626Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5084",
    "data-name": "Group 5084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M340.378,276.2s-4.467,2.794-1.437,8.565l4.576-3.061Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5085",
    "data-name": "Group 5085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M323.807,292.424a1.874,1.874,0,1,1-1.871-1.942A1.907,1.907,0,0,1,323.807,292.424Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5086",
    "data-name": "Group 5086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M342.575,280.489a1.874,1.874,0,1,1-1.871-1.941A1.909,1.909,0,0,1,342.575,280.489Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5087",
    "data-name": "Group 5087"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M303.927,244.7c0,.69-.96,1.249-2.143,1.248s-2.142-.561-2.141-1.251.96-1.25,2.143-1.249S303.927,244.009,303.927,244.7Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5088",
    "data-name": "Group 5088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M285.646,255.069a2.13,2.13,0,1,1-2.077-1.664A1.906,1.906,0,0,1,285.646,255.069Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5089",
    "data-name": "Group 5089"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M302.893,254.027c0,1.063-1.323,1.924-2.953,1.923s-2.952-.864-2.951-1.927,1.323-1.923,2.953-1.922S302.893,252.965,302.893,254.027Z",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5090",
    "data-name": "Group 5090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M326.583,279.723c-1.33.605-2.972-.236-3.667-1.878a3.076,3.076,0,0,1,1.151-4.067c1.33-.605,2.972.235,3.667,1.877A3.077,3.077,0,0,1,326.583,279.723Z",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5095",
    "data-name": "Group 5095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5092",
    "data-name": "Group 5092"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M285.083,245.815l11.545,12.15s4.618,5.283,7.73,2.787-1.258-7.167-2.181-8.524-12.236-15.093-12.236-15.093Z",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5094",
    "data-name": "Group 5094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5093",
    "data-name": "Group 5093"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M291.038,234.853a7.217,7.217,0,0,1-.443,2.11,22.485,22.485,0,0,1-2.049,4.789,16.147,16.147,0,0,1-3.282,4.058,5.846,5.846,0,0,1-1.787,1.216,18.423,18.423,0,0,1,1.535-1.485,19.782,19.782,0,0,0,3.084-4.051C290.089,238.017,290.861,234.795,291.038,234.853Z",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5098",
    "data-name": "Group 5098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5097",
    "data-name": "Group 5097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M183.584,282.429a4.3,4.3,0,0,1-.54.529l-1.613,1.44-6.008,5.211c-5.093,4.375-12.162,10.382-20.038,16.934s-15.082,12.4-20.374,16.541c-2.639,2.077-4.812,3.711-6.327,4.821l-1.761,1.257a4.139,4.139,0,0,1-.634.409,4.088,4.088,0,0,1,.572-.494l1.7-1.334c1.475-1.159,3.612-2.835,6.22-4.947,5.229-4.208,12.391-10.1,20.27-16.653l20.133-16.815,6.114-5.084,1.677-1.366A4.012,4.012,0,0,1,183.584,282.429Z",
    fill: "#eb996e"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxsave);
export default __webpack_public_path__ + "static/media/taxsave.6e339ba2500a683ae22f345b5a8b8786.svg";
export { ForwardRef as ReactComponent };